import React from 'react';

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card py-8 sm:py-12" data-testid="footer">
      <div className="container mx-auto px-4 sm:px-6 md:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="text-center sm:text-left">
            <div className="font-black text-xl uppercase tracking-tight mb-4">
              NEXT<span className="text-primary">/</span>GEN
            </div>
            <p className="text-sm text-muted-foreground">
              Elite managed IT services for modern businesses.
            </p>
          </div>

          {/* Links */}
          <div className="text-center sm:text-left">
            <h4 className="font-semibold uppercase text-sm mb-4 tracking-wider">Quick Links</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="#services" className="hover:text-primary transition-colors">Services</a></li>
              <li><a href="#about" className="hover:text-primary transition-colors">About</a></li>
              <li><a href="#contact" className="hover:text-primary transition-colors">Contact</a></li>
              <li><a href="/admin" className="hover:text-primary transition-colors" data-testid="admin-login-link">Admin Login</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center sm:text-left sm:col-span-2 md:col-span-1">
            <h4 className="font-semibold uppercase text-sm mb-4 tracking-wider">Contact</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="break-all">support@nextgennetworksolutions.com</li>
              <li>740-302-5607</li>
              <li>P.O. Box 419</li>
              <li>Greenup, KY 41144</li>
              <li className="pt-2 text-primary font-medium">24/7 Support Available</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-xs sm:text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} NextGen Network Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
